export const hiddenFilterPostFix = 'hiddenFilter';
export const filterValuesPostFix = 'filterValues';
export const sortDataPostFix = 'sortData';
export const filterModelPostFix = 'filterModel';
export const paginationConfig = 'paginationConfig';
export const shownFilters = 'shownFilters';

export const keyConcentrator = '_';
export class ComponentStorageKeyProvider{
    public readonly id: string;

    /**
     * The scope keeps the cached state of a component that is rendered for several
     * entities - a client tab for instance - separated per entity. Without it every
     * entity shares one cache entry and restores the state of the previous one.
     */
    constructor(id: string, scope?: string | number) {
        this.id = ComponentStorageKeyProvider.isEmptyScope(scope) ? id : id + keyConcentrator + scope;
    }

    private static isEmptyScope(scope: string | number): boolean {
        return scope === null || scope === undefined || scope === '' || (typeof scope === 'number' && isNaN(scope));
    }
    getHiddenFilterKey(){
        return this.id + keyConcentrator + hiddenFilterPostFix;
    }
    getFilterValueKey(){
        return this.id + keyConcentrator + filterValuesPostFix;
    }
    getSortDataKey(){
        return this.id + keyConcentrator + sortDataPostFix;
    }
    getPaginationConfigKey(){
        return this.id + keyConcentrator + paginationConfig;
    }
    getShownFilterKey(){
        return this.id + keyConcentrator + shownFilters;
    }
    getFilterModelKey(){
        return this.id + keyConcentrator + filterModelPostFix;
    }
}
